export interface KeyLaunch {
  title: string;
  date: string;
  url: string;
}

export const KEY_LAUNCHES: KeyLaunch[] = [
  {
    title: "Fortune Reporting enables Cognos Marketplace Rollups on Fortune 2.0",
    date: "November 4, 2025",
    url: "https://console.finergy.amazon.dev/launch-announcements/a6b2f537-7b36-4913-944b-15d3fa581e32?status=approved"
  },
  {
    title: "Fortune Reporting launches prior year YTD flag in Fortune 2.0",
    date: "October 24, 2025",
    url: "https://console.finergy.amazon.dev/launch-announcements/a190ee66-2de7-4a1f-af09-dbaef5cb66d5?status=approved"
  },
  {
    title: "WW Ops Finance S&A launches Hydra Customer Fulfillment (CF)",
    date: "October 15, 2025",
    url: "https://console.finergy.amazon.dev/launch-announcements/8700a324-2af9-43b9-a647-ba8db82ee6ba?status=approved"
  },
  {
    title: "Fortune Reporting enables ten P&L slices on Fortune 2.0",
    date: "October 14, 2025",
    url: "https://console.finergy.amazon.dev/launch-announcements/9a7e869f-56c8-4654-b653-a5713b919ef5?status=approved"
  },
  {
    title: "Fortune Reporting launches Cost-to-Serve (CTS) view in Fortune 2.0",
    date: "October 14, 2025",
    url: "https://console.finergy.amazon.dev/launch-announcements/a229a592-acbe-49db-96d4-a3b76978abcc?status=approved"
  }
];
